import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Sissejuhatus</Summary>
        <Details>
          <Text>
            Selle privaatsusteate on koostanud <strong>Fresh Finance OÜ</strong>{" "}
            (edaspidi <strong>Fresh Finance</strong> või <strong>meie</strong>),
            Eesti Vabariigis registreeritud ä riü hing, registrikood 12243370,
            juriidiline aadress Tartu mnt 83, 10115 Tallinn, Eesti. Fresh
            Finance on litsenseeritud krediidiandja, tegevusloa nr 4.1- 1/45.
          </Text>
          <Text>
            Privaatsusteade kehtib kõigile isikutele, kelle käest või kohta
            Fresh Finance kogub või saab isikuandmeid oma teenuste osutamise või
            muu majandustegevuse käigus (edaspidi <strong>andmesubjekt</strong>{" "}
            või <strong>teie</strong>). Fresh Finance tegeleb muuhulgas AS-i
            PlusPlus Capital (registrikood 11919806, aadress Tartu mnt 83,
            10115, edaspidi <strong>PlusPlus Capital</strong>) või PlusPlus
            Baltic OÜ (registrikood 12273105, aadress Tartu mnt 83, 10115
            Tallinn, edaspidi <strong>PlusPlus Baltic</strong>, PlusPlus Capital
            ja PlusPlus Baltic edaspidi koos nimetatud ka kui Võlausaldajad)
            nimel krediidihaldustegevusega Krediidiinkassode- ja ostjate seaduse
            tähenduses.
          </Text>
          <Text>
            Privaatsusteade kehtib Fresh Finance poolt töödeldavatele
            isikuandmetele ja kirjeldab, kuidas Fresh Finance teie isikuandmeid
            kogub, kasutab ja muul viisil töötleb.
          </Text>
          <Text>
            Fresh Finance töötleb teie isikuandmeid kooskõlas kohaldatavate
            andmekaitsealaste õigusaktidega, sh andmekaitse üldmäärusega (määrus
            (EL) 2016/679) (edaspidi <strong>üldmäärus</strong>) ja mistahes
            muude kohaldatavate andmekaitsealaste õigusaktidega.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Vastutav töötaja</Summary>
        <Details>
          <Text>
            Fresh Finance on teie isikuandmete vastutav töötleja ning vastutab
            teie isikuandmete töötlemise eest kooskõlas selle privaatsusteate ja
            kohaldatavate andmekaitsealaste õigusaktidega.
          </Text>
          <Text>Andmekaitse eest vastutava isiku kontaktandmed:</Text>
          <Text>
            <ul>
              <li>Krõõt Kilvet</li>
              <li>
                <strong>Aadress:</strong> Tartu mnt 83, 10115 Tallinn, Eesti
              </li>
              <li>
                <strong>E-post:</strong>{" "}
                <a
                  href="mailto:kroot.kilvet@punkfinance.ee"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  kroot.kilvet@punkfinance.ee
                </a>
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Töödeldavad isikuandmed</Summary>
        <Details>
          <Text>
            Me võime koguda, säilitada, kasutada, edastada ja mistahes muul
            viisil töödelda teie järgmisi isikuandmeid:
            <ul>
              <li>
                isikut tuvastavad andmed (eesnimi, perekonnanimi, isikukood,
                sünniaeg ja -koht, kodakondsus, isikut tõendava dokumendi andmed
                ja koopia, foto jne);
              </li>
              <li>
                kontaktandmed (aadress, telefoninumber, e-posti aadress jne);
              </li>
              <li>
                tööhõive andmed (praegune tööandja, tööhõive ajalugu, ametikoht
                jne);
              </li>
              <li>
                finantsandmed (sissetulek, vara, kohustused, tagatised ja pandid
                jne);
              </li>
              <li>
                lepingu- ja tehinguandmed (Võlausaldajate omandatud nõuete või
                lepingute andmed ja vastavates dokumentides sisalduvad andmed,
                pangakonto number, sissetuleku andmed ja vara andmed,
                Võlausaldajate omandatud nõuete või lepingutega seotud maksete
                ajalugu, maksehäirete andmed, andmed Võlausaldajate omandatud
                nõuete või lepingutega seotud teiste isikute (nt käendajad,
                kaaslaenusaajad, tagatise andjad) kohta jms);
              </li>
              <li>
                teie majandustegevusega seotud andmed, nt seotud isikute andmed
                äriregistrist;
              </li>
              <li>teie IP-aadress ja analüütikaandmed;</li>
              <li>
                karistusregistri teave, riikliku taustaga isiku teave jne.
              </li>
            </ul>
          </Text>
          <Text>
            Olenevalt isikuandmete liigist ja nende töötlemise alustest ei
            pruugi Fresh Finance suuta täita lepingulisi kohustusi ega jätkata
            lepingulist suhet juhul, kui te keeldute teatud isikuandmete
            avaldamisest.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Isikuandmete kogumise allikad</Summary>
        <Details>
          <Text>
            Kogume teie isikuandmeid järgmistest allikatest:
            <ul>
              <li>
                Teilt – teatud isikuandmeid võime saada teilt otse telefoni või
                e-posti teel või muul viisil teiega suheldes (teie poolt
                iseteeninduses täidetavad vormid, meievaheline teabevahetus ja
                erinevad õiguslikud menetlused jne);
              </li>
              <li>
                konsolideerimisgrupi ettevõtetelt, kuhu Fresh Finance kuulub;
              </li>
              <li>
                kolmandatelt isikutelt (sh avalikult ligipääsetavatest
                allikatest) nagu Võlausaldajate omandatud nõuete või lepingute
                müüjad (st algsed võlausaldajad), nõude või lepinguga seotud
                isikud (nt käendajad, kaaslaenusaajad, tagatise andjad jne),
                ametiasutused (kohtud, kohtutäiturid, pankrotihaldurid jne),
                asjakohaste elektrooniliste andmebaaside, mida peavad kolmandast
                isikust teenusepakkujad, otsingute kaudu (maksehäirete register,
                kinnistusraamat, äriregister jne) ning muud avalikult
                ligipääsetavad allikad ja otsingumootorid.
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Isikuandmete töötlemise eesmärgid ja õiguslik alus</Summary>
        <Details>
          <Text>
            Töötleme teie isikuandmeid konkreetsetel eesmärkidel ning kooskõlas
            üldmääruse ja kehtivate õigusaktidega.
          </Text>
          <Text>
            Peamised eesmärgid, milleks me teie andmeid töötleme, ja sellise
            töötlemise õiguslikud alused on järgmised:
            <ul>
              <li>
                üldmääruse artikkel 6 (1) (b) - lepingu täitmine, mille pooleks
                te olete, või lepingu või muu kokkuleppe sõlmimiseks sammude
                astumine, näiteks järgmised toimingud:
                <ul>
                  <li>
                    teie andmete sisestamine asjaomastesse registritesse
                    taustauuringu tegemiseks ja Võlausaldaja nõude täitmiseks;
                  </li>
                  <li>teie isikuandmete sisestamine meie infosüsteemidesse;</li>
                  <li>
                    nõude, mis Võlausaldajal on teie või teise asjassepuutuva
                    isiku vastu, käsitlemine ja/või sissenõudmine (vastavalt
                    asjaoludele kas teie või kolmandate isikutega suheldes või
                    muid toiminguid tehes, et asjaomane nõue täita);
                  </li>
                </ul>
              </li>
              <li>
                üldmääruse artikkel 6 (1) (c) - õigusliku või regulatiivse
                kohustuse täitmise vajadus, näiteks:
                <ul>
                  <li>Fresh Finance raamatupidamine ja auditeerimine;</li>
                  <li>
                    rahapesu ja terrorismi rahastamise tõkestamise seadusest,
                    võlaõigusseadusest, krediidiandjate ja -vahendajate
                    seadusest, raamatupidamise seadusest, audiitortegevuse
                    seadusest, rahvusvahelise sanktsiooni seadusest tulenevate
                    nõuete täitmine.
                  </li>
                </ul>
                <li>
                  üldmääruse artikkel 6 (1) (f) - vajalik meie õigustatud huvi
                  korral (meie äritegevuse läbiviimine), kui andmesubjekti huvid
                  või põhiõigused ja -vabadused ei kaalu sellist huvi üles,
                  näiteks:
                  <ul>
                    <li>
                      meie ettevõttesisene ärialane aruandlus ja teabevahetus;
                    </li>
                    <li>
                      teile nõu andmine seoses teie Võlausaldaja ees olevate
                      kohustuste efektiivse täitmisega;
                    </li>
                    <li>
                      meie IT-süsteemide, veebilehtede ja iseteenindussüsteemide
                      arendamine;
                    </li>
                    <li>uute pakkumiste tegemine;</li>
                  </ul>
                </li>
              </li>
              <li>
                üldmääruse artikkel 6 (1) (a) - eesmärkidel, mis olid välja
                toodud teilt nõusoleku saamisel, juhul kui olete andnud
                nõusoleku teie isikuandmete töötlemiseks.
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Isikuandmete jagamine</Summary>
        <Details>
          <Text>
            Selleks, et saavutada käesolevas privaatsusteates kirjeldatud
            töötlemise eesmärgid, võime edastada teie isikuandmeid järgmistele
            saajatele:
            <ul>
              <li>
                selle konsolideerimisgrupi ettevõtted, kuhu Fresh Finance
                kuulub;
              </li>
              <li>
                ametiasutused, nagu Maksu- ja Tolliamet, Finantsinspektsioon,
                rahapesu andmebüroo, andmebaaside vastutavad töötlejad;
              </li>
              <li>
                pilvepõhise salvestusteenuse pakkujad, sealhulgas pilvepõhise
                laenuhaldustarkvara pakkuja;
              </li>
              <li>klienditoe keskuse teenusepakkujad;</li>
              <li>
                ettevõtted, kes pakuvad pettuste ja finantskuritegude ennetamise
                teenuseid;
              </li>
              <li>
                muud kolmandad isikud, nagu kulleri- ja postiteenuse pakkujad,
                maksehäirete registrid, võlgade sissenõudjad, audiitorid,
                õigusteenuse pakkujad, kohtud, kohtutäiturid, pankrotihaldurid
                jne.
              </li>
            </ul>
          </Text>
          <Text>
            Me nõuame kolmandatest isikutest teenusepakkujatelt, et nad tagaksid
            teie andmete turvalisuse ja töötleksid neid andmeid meie juhiste
            kohaselt ja kooskõlas käesoleva teate, üldmääruse ja kehtivate
            õigusaktidest tulenevate nõuetega. Need kolmandad isikud võivad
            kasutada teie isikuandmeid üksnes konkreetsetel eesmärkidel
            vastavalt teenustele, mida nad meile osutavad.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Edastamine väljapoole euroopa majanduspiirkonda</Summary>
        <Details>
          <Text>
            Meie majandustegevuse käigus võidakse teie isikuandmed edastada ja
            neid võivad töödelda väljaspool Euroopa Majanduspiirkonda (edaspidi{" "}
            <strong>EMP</strong>) asuvad saajad. Näiteks võivad mõne meie
            kolmandast isikust teenusepakkuja andmeserverid asuda väljaspool
            EMP-d.
          </Text>
          <Text>
            Fresh Finance rakendab meetmeid, et tagada väljapoole EMP-d
            edastatamisel piisav kaitse vastavalt käesolevale teatele,
            üldmäärusele ja kehtivatele õigusaktidele. Riikide puhul, kus ei ole
            tagatud piisav andmekaitse tase, tugineme edastusel asjaomastele
            kaitsemehhanismidele, nagu Euroopa Komisjoni poolt kinnitatud
            standardsed andmekaitsesätted või heakskiidetud
            sertifitseerimismehhanismidele koos andmete saajale siduvate ja
            jõustatavate kohustustega. Isikuandmete edastamisel Ameerika
            Ühendriikidesse võib saaja olla liitunud ELi-USA
            andmekaitseraamistikuga Privacy Shield ja seega olla tunnustatud kui
            piisava andmekaitse taseme tagaja, mis teeb võimalikuks andmete
            edastamise EList USAsse.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Isikuandmete säilitamine ja turvalisus</Summary>
        <Details>
          <Text>
            Me töötleme teie isikuandmeid lepingu või muu kokkuleppe täitmise
            ajal ning säilitame seejärel teie isikuandmeid seni, kuni see on
            vajalik selle eesmärgi täitmiseks, milleks me neid kogusime, kaasa
            arvatud meie suhtes kohalduvate õiguslike, maksualaste või
            raamatupidamiskohustuste täitmiseks.
          </Text>
          <Text>
            Lepingute ja/või tehingutega seotud isikuandmed on osa meie
            raamatupidamise ja majandustegevuse dokumentatsioonist ning neid
            säilitatakse 10 aastat alates nende kirjendamise aasta lõpust.
            Säilitusperiood võib olla pikem, kui teie isikuandmete töötlemine on
            nõutav muude meie põhitegevusega seotud nõuete täitmiseks. Kui
            säilitusperiood on lõppenud, kustutame isikuandmed või muudame need
            anonüümseks.
          </Text>
          <Text>
            Me säilitame mitteisikulisi ja statistilisi andmeid meie
            veebisaitide kasutamise kohta 3 aastat.
          </Text>
          <Text>
            Rakendame üldiselt aktsepteeritud tehnoloogilisi ja operatsioonilisi
            turvalisuse standardeid, et kaitsta teie isikuandmeid kaotsimineku,
            väärkasutuse, muutmise või hävitamise eest. Nõuame kõigilt oma
            töötajatelt isikuandmete konfidentsiaalsusnõude järgimist ning
            sellistele andmetele on juurdepääs ainult selleks volitatud
            isikutel.
          </Text>
          <Text>
            Astume samme selleks, et tagada asjakohaste turvameetmete
            rakendamine teie isikuandmete kaitsega seotud õiguste jätkuvaks
            kaitseks.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Teie õigused</Summary>
        <Details>
          <Text>
            Teil on oma töödeldavate isikuandmete suhtes erinevaid õigusi.
          </Text>
          <Text>
            <ul>
              <li>
                <strong>õigus taotleda ligipääsu:</strong> teil on õigus
                taotleda meilt kinnitust selle kohta, millist informatsiooni me
                teie osas mis tahes ajahetkel töötleme. Me ei pruugi õiguslikel
                põhjustel alati olla kohustatud teie taotlust täitma. Kui
                keeldume teie taotluse täitmisest, teavitame teid keeldumise
                põhjustest;
              </li>
              <li>
                <strong>õigus andmete parandamisele:</strong>teil on õigus
                nõuda, et me parandaksime teie mis tahes ebatäpsed või
                mittetäielikud isikuandmed, mida töötleme. Kui oleme jaganud
                selliseid isikuandmeid kolmandate isikutega, teavitame neid
                parandamisest, välja arvatud juhul, kui see on võimatu või see
                eeldaks ebaproportsionaalseid jõupingutusi. Me ei pruugi
                õiguslikel põhjustel alati olla kohustatud teie taotlust täitma.
                Kui keeldume teie taotluse täitmisest, teavitame teid keeldumise
                põhjustest;
              </li>
              <li>
                <strong>õigus andmete kustutamisele:</strong> teatud asjaoludel
                on teil õigus nõuda, et kustutaksime teie isikuandmed. Me ei
                pruugi õiguslikel põhjustel alati olla kohustatud teie taotlust
                täitma. Kui keeldume teie taotluse täitmisest, teavitame teid
                keeldumise põhjustest;
              </li>
              <li>
                <strong>õigus isikuandmete töötlemise piiramisele:</strong>{" "}
                teatud asjaoludel on teil õigus nõuda, et piiraksime teie
                isikuandmete töötlemist. See tähendab, et võime üksnes teie
                isikuandmeid säilitada ja ei või andmeid töödelda muul viisil.
                Me ei pruugi õiguslikel põhjustel alati olla kohustatud teie
                taotlust täitma. Kui keeldume teie taotluse täitmisest,
                teavitame teid keeldumise põhjustest;
              </li>
              <li>
                <strong>õigus esitada vastuväiteid:</strong> teatud asjaoludel
                on teil õigus esitada vastuväiteid teie isikuandmete töötlemise
                suhtes. Me ei pruugi õiguslikel põhjustel alati olla kohustatud
                teie taotlust täitma. Kui keeldume teie taotluse täitmisest,
                teavitame teid keeldumise põhjustest;
              </li>
              <li>
                <strong>andmete ülekandmise õigus:</strong> teil on õigus
                edastada isikuandmeid erinevate vastutavate töötlejate vahel,
                arvestades seejuures kohalduvatest õigusaktidest tulenevaid
                võimalikke piiranguid. See tähendab, et saate edastada andmeid,
                mida teie suhtes töötleme, erinevatele teenusepakkujtele või
                kolmandatele osapooltele. Esitame teie andmed üldkasutatavas
                vormingus ning masinloetaval kujul, et saaksite andmed edastada;
              </li>
              <li>
                <strong>
                  õigus mitte olla üksnes automatiseeritud töötlusel põhineva
                  otsuse subjektiks:
                </strong>{" "}
                teil on õigus mitte olla otsuse subjektiks, mis põhineb üksnes
                automatiseeritud töötlusel, sealhulgas profiilianalüüsil, mis
                toob kaasa teid puudutavaid õiguslikke tagajärgi või avaldab
                teile sarnast mõju. Kohalduvatest õigusaktidest võib tulla
                piiranguid selle õiguse teostamisele. Me ei pruugi õiguslikel
                põhjustel alati olla kohustatud teie taotlust täitma. Kui
                keeldume teie taotluse täitmisest, teavitame teid keeldumise
                põhjustest.
              </li>
              <li>
                <strong>järelevalveasutusele kaebuse esitamise õigus:</strong>{" "}
                Kui leiate, et teie isikuandmete töötlemise alaseid õigusi on
                rikutud, on teil õigus esitada kaebus selle riigi
                andmekaitseasutusele, kus on teie alaline elukoht. Selliste
                asutuste kontaktandmed leiate aadressilt{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://edpb.europa.eu/about-edpb/board/members_en"
                >
                  https://edpb.europa.eu/about-edpb/board/members_en
                </a>
                .
              </li>
            </ul>
          </Text>
          <Text>
            Teil on õigus kasutada oma õigusi kooskõlas üldmääruse ja kehtivate
            õigusaktide nõuetega.
          </Text>
          <Text>
            Oma õiguste kasutamiseks võtke palun meiega ühendust e-posti
            aadressil support@freshfinance.ee. Teie isikuandmete töötlemisega
            seonduvate õiguste kohta teabe vahetamisel võib meil olla vaja
            küsida teilt teie isiku tuvastamiseks teatud teavet või dokumente.
            See on vajalik, et tagada, et isikuandmeid ei avaldata ühelegi
            isikule, kelleks ei ole teie või kellel ei ole õigust teie
            isikuandmeid saada.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Muudatused</Summary>
        <Details>
          <Text>
            Kui Fresh Finance muudab töödeldavate isikuandmete kategooriaid või
            töötlemise eesmärke, teeme privaatsusteatesse vastavasisulised
            muudatused ja teavitame teid nendest.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Lisateave</Summary>
        <Details>
          <Text>
            Kui teil on privaatsusteate või oma isikuandmete kohta küsimusi,
            saatke meile e-kiri aadressil{" "}
            <a
              href="mailto:support@freshfinance.ee"
              target="_blank"
              rel="noopener noreferrer"
            >
              support@freshfinance.ee
            </a>
          </Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
